package app.softwork.composetodo.users

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*

@Composable
fun Users() {
    Text("User placeholder")
}
